import { render, staticRenderFns } from "./NiceDialog.vue?vue&type=template&id=55994c3e&scoped=true"
import script from "./NiceDialog.vue?vue&type=script&lang=js"
export * from "./NiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55994c3e",
  null
  
)

export default component.exports